import 'normalize.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
import ScrollToTop from './ScrollToTop';
import { HashRouter } from 'react-router-dom';

ReactDOM.render(
    <React.StrictMode>
        <HashRouter>
            <ScrollToTop />
            <App />
        </HashRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
